/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_GrowersInputs */

const vi_api_keys_perm_growers = /** @type {(inputs: Api_Keys_Perm_GrowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng`)
};

/**

* @param {Api_Keys_Perm_GrowersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_growers = /** @type {((inputs?: Api_Keys_Perm_GrowersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_GrowersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_growers(inputs)
});